import * as oneTrust from './oneTrust/index';
import * as tealium from './tealium/index';
import * as evidon from './evidon/index';
import * as didomi from './didomi/index';
import * as sme from './sme/index';

export { oneTrust, tealium, evidon, didomi, sme };
